import React from "react";
import { useDispatch } from "react-redux";
import { LeftPanel, MainContainer, RightPanel } from "../login/LoginLayout";
import { StackPanelLogo } from "../login/StackCarePanelLogo";
import { useTranslation } from "react-i18next";
import {
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Button,
  Box,
} from "@material-ui/core";
import { Views } from "../../helpers/constants";
import { useHistory } from "react-router-dom";
import AccountManagementHeader from "../login/AccountManagementHeader";
import { resetInvoice } from "./dashboardSlice";
import { logout } from "../login/loginSlice";
import LeftPanelFooter from "../login/LeftPanelFooter";
import SubscriptionManagementOptions from "./SubscriptionManagementOptions";
import SignOut from "./SignOut";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      fontSize: "1.8rem",
      width: "100%",
      marginTop: "90px",
    },
    subText: {
      color: theme.palette.dark.main,
      fontSize: "1.2rem",
      marginTop: "40px",
      lineHeight: "1.5rem",
      width: "440px",
    },
    buttons: {
      color: theme.palette.paused.main,
      fontWeight: "bold",
      padding: "0px 0px",
      "&:hover": {
        background: "transparent",
      },
    },
    buttonBoxTop: {
      marginTop: "50px",
    },
    buttonBoxBottom: {
      marginTop: "20px",
    },
    signOut: {
      color: theme.palette.paused.main,
      width: "65px",
      padding: "0px 0px",
      "&:hover": {
        background: "transparent",
      },
    },
  })
);

export default function SubscriptionConfirmation() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  /* ---- Utils ---- */
  const handleBackToLogin = () => {
    dispatch(logout());
    history.push(Views.LOGIN);
  };

  const handleBacktoBilling = () => {
    dispatch(resetInvoice());
    history.push(Views.SUBSCRIPTION);
  };

  return (
    <MainContainer>
      <LeftPanel>
        <StackPanelLogo />
        <AccountManagementHeader />
        <SubscriptionManagementOptions />
        <SignOut />
        <LeftPanelFooter />
      </LeftPanel>
      <RightPanel>
        <Typography className={classes.mainText}>{t("Success")}</Typography>
        <Typography className={classes.subText}>
          {t("sub_update_success")}
        </Typography>
        <Typography className={classes.subText}>
          {t("update_thanks")}
        </Typography>
        <Box className={classes.buttonBoxTop}>
          <Button onClick={handleBacktoBilling} className={classes.buttons}>
            {t("back_billing")}
          </Button>
        </Box>
        <Box className={classes.buttonBoxBottom}>
          <Button onClick={handleBackToLogin} className={classes.buttons}>
            {t("sign_out")}
          </Button>
        </Box>
      </RightPanel>
    </MainContainer>
  );
}
